export const selectIsLoading = (state) => state.global?.isLoading ?? false;
export const selectIsError = (state) => state.global.isError;
